const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransactions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.0478072,0,0,0.0478072,0.0477051,-0.404639)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M445.651,201.95C444.166,192.642 435.416,186.301 426.108,187.786C416.8,189.271 410.459,198.021 411.944,207.329C411.96,207.431 411.977,207.532 411.995,207.633C429.375,309.944 360.525,406.972 258.214,424.352C155.903,441.732 58.875,372.882 41.495,270.571C24.115,168.26 92.966,71.232 195.276,53.852C258.195,43.164 322.238,65.142 365.335,112.213L319.73,127.403C310.786,130.379 305.949,140.041 308.924,148.985C308.925,148.987 308.926,148.99 308.927,148.992C311.903,157.936 321.565,162.773 330.509,159.798C330.512,159.797 330.514,159.796 330.516,159.796L402.916,135.663C409.888,133.341 414.591,126.816 414.59,119.467L414.59,47.067C414.59,37.641 406.949,30 397.523,30C388.097,30 380.456,37.641 380.456,47.067L380.456,79.411C292.564,-4.185 153.545,-0.702 69.949,87.19C-13.647,175.082 -10.165,314.101 77.728,397.698C165.621,481.295 304.639,477.812 388.236,389.919C435.905,339.799 457.179,270.152 445.651,201.95Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.80914,0,0,0.80914,22.5531,52.9938)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256,151C280.813,151 301,171.187 301,196C301,204.284 307.716,211 316,211C324.284,211 331,204.284 331,196C331,154.645 297.355,121 256,121C214.645,121 181,154.645 181,196L181,241L166,241C157.716,241 151,247.716 151,256C151,264.284 157.716,271 166,271L181,271C180.733,272.404 184.046,306.742 155.394,335.393C145.976,344.81 152.646,361 166,361L316,361C324.284,361 331,354.284 331,346C331,337.716 324.284,331 316,331L196.061,331C212.693,301.422 210.859,272.163 211,271L256,271C264.284,271 271,264.284 271,256C271,247.716 264.284,241 256,241L211,241L211,196C211,171.187 231.187,151 256,151Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactions);
export default __webpack_public_path__ + "static/media/transactions.fa56020c52051ae28eaadab337c169a4.svg";
export { ForwardRef as ReactComponent };